(function () {
  "use strict"; // Start of use strict
  
  let keepHeaderFixed = false;
  if (window.theme && window.theme !== 'otostolik') {
    keepHeaderFixed = true;
  }

  // Collapse Navbar
  function navbarCollapse() {
    const mainNav = document.querySelector('#mainNav');
    if(!mainNav) {
      return;
    }
    const rect = mainNav.getBoundingClientRect();
    if(!rect) {
      return;
    }
    const offset = {
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX,
    };
    if (offset.top > 100 || keepHeaderFixed) {
      mainNav.classList.add("navbar-scrolled");
    } else {
      mainNav.classList.remove("navbar-scrolled");
    }
  };

  navbarCollapse();

  if (!keepHeaderFixed) {
    window.addEventListener('scroll', navbarCollapse);
  }

})();
